import { ArrowRight, LockKeyhole, ShieldCheck } from "lucide-react";

export default function DashboardLogin({ onLogin }) {
  return (
    <main className="mandate-auth" data-testid="mandate-dashboard-login">
      <section className="mandate-auth-panel">
        <p className="mandate-overline">Pimp My Place · Interne</p>
        <h1>Machine<br />à Mandats.</h1>
        <p>
          Un espace réservé à l’équipe pour examiner des signaux immobiliers publics,
          sourcés et priorisés.
        </p>
        <button className="mandate-primary-button" onClick={onLogin} data-testid="mandate-google-login-button">
          Continuer avec Google <ArrowRight size={18} />
        </button>
        <div className="mandate-auth-notes" data-testid="mandate-auth-notes">
          <span><LockKeyhole size={16} /> Accès sur liste blanche</span>
          <span><ShieldCheck size={16} /> Données publiques uniquement</span>
        </div>
      </section>
    </main>
  );
}